import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  TextField,
  MenuItem,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormControl,
  InputAdornment,
} from "@mui/material";
import OtpModal from "./OTPModal";
import { useNavigate } from "react-router-dom";
import CustomSnackbar from "../../../newTestPreo/components/snackbar/Snackbar";
import { CustomTextField } from "../../components/textfield/CustomTextField";

const labelStyle = {
  fontFamily: "Inter, sans-serif",
  fontWeight: 600,
  fontSize: "15px",
  marginBottom: "6px",
  display: "block",
};

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function RegisterPage2() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobile, setMobile] = useState(null);
  const [mobileError, setMobileError] = useState("");
  const [isdCodeList, setIsdCodeList] = useState([]);
  const [countryCode, setCountryCode] = useState("91");
  const [role, setRole] = useState("student");
  const [servicesList, setServicesList] = useState([]);
  const [service, setService] = useState("");
  const [serviceError, setServiceError] = useState("");
  const [focused, setFocused] = useState(false);
  const [serviceFocused, setServiceFocused] = useState(false);
  const [otpOpen, setOtpOpen] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}services`)
      .then((response) => response.json())
      .then((data) => {
        const firstTwo = data.slice(0, 2);
        setServicesList(firstTwo);
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}countries`)
      .then((response) => response.json())
      .then((data) => {
        const sortedData = [...data].sort(
          (a, b) => a.phone_code - b.phone_code
        );
        const uniqueArray = sortedData.filter(
          (obj, index, self) =>
            index ===
            self.findIndex(
              (t) => t.phone_code === obj.phone_code && obj.phone_code !== null
            )
        );
        setIsdCodeList(uniqueArray);
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();

    const nameRegex = /^[A-Za-z]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^\d{8,15}$/;

    const errors = {};

    // First name
    if (!firstName.trim()) {
      errors.firstName = "Name is required";
    } else if (!nameRegex.test(firstName.trim())) {
      errors.firstName = "Enter a valid name (letters only)";
    }

    // Last name
    if (!lastName.trim()) {
      errors.lastName = "Name is required";
    } else if (!nameRegex.test(lastName.trim())) {
      errors.lastName = "Enter a valid name (letters only)";
    }

    // Email
    if (!email.trim()) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(email.trim())) {
      errors.email = "Enter a valid email address";
    }

    // Service
    if (!service) {
      errors.service = "Please select a service";
    }

    // Mobile
    if (!mobile.trim()) {
      errors.mobile = "Mobile number is required";
    } else if (!mobileRegex.test(mobile)) {
      errors.mobile = "Mobile number must be valid digits, no spaces";
    }

    setFirstNameError(errors.firstName || "");
    setLastNameError(errors.lastName || "");
    setEmailError(errors.email || "");
    setServiceError(errors.service || "");
    setMobileError(errors.mobile || "");

    if (Object.keys(errors).length > 0) return;

    const payload = {
      mobile: mobile,
      mobile_country_code: countryCode,
      email: email,
    };

    try {
      localStorage.clear();
      const response = await fetch(
        `${API_ENDPOINT}studentsignup/register/generatingotp?platform=1`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.status == 200 || response.ok) {
        let result = await response.json();
        showSnackbar("OTP sent successfully!");
        setOtpOpen(true);
      } else {
        let result = await response.json();
        showSnackbar(`${result.message}`, "error");
      }
    } catch (error) {
      showSnackbar("Error sending OTP", "error");
    }
  };

  const handleOtpVerify = async (otp) => {
    const formData = {
      first_name: firstName,
      last_name: lastName,
      user_type: role,
      service,
      email,
      mobile_country_code: countryCode,
      mobile,
      otp,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}sapregistration/verify/signupotp?platform=1`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (response.status === 200 || response.ok) {
        showSnackbar("OTP verified successfully!", "success");
        setTimeout(() => {
          setOtpOpen(false);
          localStorage.setItem("userId", result?.data?.user_id);
          localStorage.setItem("serviceId", service);
          navigate("/registrationform");
        }, 2000);
      } else if (response.status === 409) {
        showSnackbar(
          "This number has an existing account.Please login to proceed!",
          "error"
        );
        setTimeout(() => {
          setOtpOpen(false);
          navigate("/login");
        }, 3000);
      } else {
        showSnackbar(`${result.message}`, "error");
      }
    } catch (error) {
      showSnackbar("Error verifying OTP.Please try again", "error");
    }
  };

  return (
    <>
      <Grid
        container
        minHeight="100vh"
        minWidth="100vh"
        sx={{
          fontFamily: "Inter, sans-serif",
          position: "relative",
          backgroundImage: `url('/Signupimages/signUp.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Left Side Text Overlay */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            position: "relative",
            zIndex: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            p: { xs: 3, md: 5 },
            color: "#fff",
          }}
        >
          {/* Logo */}
          <Box sx={{ mb: 4 }}>
            <img
              src="/Signupimages/logo.png"
              alt="Logo"
              style={{ width: "100px", height: "auto" }}
            />
          </Box>

          {/* Heading */}
          <Box sx={{ mt: "auto", mb: { xs: 4, md: 6 } }}>
            <Typography
              sx={{
                fontFamily: "Crimson Pro",
                fontWeight: 800,
                fontStyle: "normal", // ExtraBold handled by fontWeight
                fontSize: { xs: "32px", md: "50px" }, // matches your 58px
                lineHeight: "100%",
                letterSpacing: "0px",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Soar High, Score Higher In Your 1st Attempt.
            </Typography>
          </Box>
        </Grid>

        {/* Right Side White Form Card */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            position: "relative",
            zIndex: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 4,
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 600, // Smaller width
              backgroundColor: "white",
              borderRadius: "18px", // Smaller rounding
              boxShadow: "0px 4px 18px rgba(0,0,0,0.12)",
              p: 2.5, // Smaller padding
            }}
          >
            {/* Heading */}
            <Typography
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                fontSize: "22px", // Smaller Title
                textAlign: "center",
                color: "#161719",
                mb: 1,
              }}
            >
              Welcome to{" "}
              <span
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 700,
                  fontSize: "22px",
                  color: "#3D025B",
                }}
              >
                Scholastic Test Masters
              </span>
            </Typography>

            {/* Sub Heading */}
            <Typography
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                fontSize: "14px", // Smaller subtitle
                textAlign: "center",
                color: "#4A4A4A",
                mb: 2.5,
              }}
            >
              Create your account and unlock the world of international
              education.
            </Typography>

            <form onSubmit={handleRegister}>
              <Grid container spacing={1.5}>
                <Grid item xs={6}>
                  <CustomTextField
                    label="Enter Your First Name"
                    placeholder="Enter your first name"
                    required
                    value={firstName}
                    onChange={(e) => {
                      const onlyLetters = e.target.value.replace(
                        /[^A-Za-z ]/g,
                        ""
                      );
                      setFirstName(onlyLetters);
                    }}
                    error={!!firstNameError}
                    helperText={firstNameError}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        minHeight: "32px",
                        "& input": { padding: "6px 10px", fontSize: "14px" },
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <CustomTextField
                    label="Enter Your Last Name"
                    placeholder="Enter your last name"
                    required
                    value={lastName}
                    onChange={(e) => {
                      const onlyLetters = e.target.value.replace(
                        /[^A-Za-z ]/g,
                        ""
                      );
                      setLastName(onlyLetters);
                    }}
                    error={!!lastNameError}
                    helperText={lastNameError}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        minHeight: "32px",
                        "& input": { padding: "6px 10px", fontSize: "14px" },
                      },
                    }}
                  />
                </Grid>
              </Grid>

              {/* Role Selection */}
              <FormControl fullWidth required sx={{ mb: 2 }}>
                <label style={labelStyle}>Student or Parent/Guardian *</label>

                <RadioGroup
                  row
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  sx={{
                    display: "flex",
                    gap: "12px",
                    border: "1px solid #ccc",
                    borderRadius: "10px",
                    padding: "6px 10px",
                  }}
                >
                  <FormControlLabel
                    value="student"
                    control={
                      <Radio
                        sx={{
                          color: "#ccc",
                          "&.Mui-checked": { color: "#3B035E" },
                        }}
                      />
                    }
                    label="Student"
                    sx={{
                      "& .MuiFormControlLabel-label": { fontSize: "13px" },
                    }}
                  />
                  <FormControlLabel
                    value="parent"
                    control={
                      <Radio
                        sx={{
                          color: "#ccc",
                          "&.Mui-checked": { color: "#3B035E" },
                        }}
                      />
                    }
                    label="Parent/Guardian"
                    sx={{
                      "& .MuiFormControlLabel-label": { fontSize: "13px" },
                    }}
                  />
                </RadioGroup>
              </FormControl>

              <FormControl fullWidth required sx={{ marginBottom: "25px" }}>
                <label style={labelStyle}>
                  Select Service <span style={{ color: "red" }}>*</span>
                </label>
                <TextField
                  select
                  value={service}
                  onChange={(e) => {
                    setService(e.target.value);
                    if (serviceError) setServiceError("");
                  }}
                  onFocus={() => setServiceFocused(true)}
                  onBlur={() => setServiceFocused(false)}
                  variant="outlined"
                  size="small"
                  error={!!serviceError}
                  helperText={serviceError}
                  SelectProps={{
                    displayEmpty: true,
                  }}
                  sx={{
                    backgroundColor:
                      !serviceFocused && !service ? "#f0f0f0" : "#fff",
                    borderRadius: "12px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      minHeight: "36px",
                      padding: 0,
                      "& select": {
                        padding: "8px 12px",
                        fontSize: "15px",
                        fontFamily: "Inter",
                      },
                      "& fieldset": {
                        borderColor: serviceFocused ? "#3B035E" : "#ccc",
                        borderWidth: serviceFocused ? "3px" : "1px",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#3B035E",
                      },
                    },
                  }}
                >
                  <MenuItem value="" disabled>
                    <span style={{ color: "#888" }}>Select a service</span>
                  </MenuItem>

                  {servicesList.map((service) => (
                    <MenuItem key={service.id} value={service.id}>
                      {service.service_name}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>

              <label style={labelStyle}>Enter Registered Mobile Number</label>

              <Box sx={{ display: "flex", gap: "8px", mb: 2 }}>
                {/* Country Code */}
                <TextField
                  select
                  size="small"
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                  sx={{
                    width: "120px",
                    backgroundColor: "#F5F5F5",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-root": {
                      height: "42px",
                      borderRadius: "8px",
                      "& fieldset": { borderColor: "#ddd" },
                    },
                    "& .MuiSelect-select": {
                      display: "flex",
                      alignItems: "center",
                      padding: "10px",
                      fontSize: "14px",
                    },
                  }}
                >
                  {isdCodeList.map((option) => (
                    <MenuItem
                      key={option.locale_code}
                      value={option.phone_code}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={`https://flagcdn.com/w40/${option.locale_code.toLowerCase()}.png`}
                          style={{
                            width: "20px",
                            height: "15px",
                            marginRight: "6px",
                            borderRadius: "2px",
                          }}
                        />
                        +{option.phone_code}
                      </Box>
                    </MenuItem>
                  ))}
                </TextField>

                {/* Mobile Input */}
                <TextField
                  type="tel"
                  fullWidth
                  placeholder="Enter your registered mobile number"
                  value={mobile}
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/\D/g, ""); // remove all non-numbers
                    setMobile(onlyNums);
                  }}
                  error={!!mobileError}
                  helperText={mobileError}
                  size="small"
                  sx={{
                    backgroundColor: "#F5F5F5",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-root": {
                      height: "42px",
                      borderRadius: "8px",
                      "& fieldset": { borderColor: "#ddd" },
                    },
                    "& input": {
                      padding: "10px 14px",
                      fontSize: "14px",
                    },
                  }}
                />
              </Box>

              <CustomTextField
                label="Enter Email ID"
                placeholder="Enter your mail ID"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={!!emailError}
                helperText={emailError}
                sx={{
                  mb: 2,
                  backgroundColor: "#F5F5F5",
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": {
                    height: "42px",
                    borderRadius: "8px",
                    "& fieldset": { borderColor: "#ddd" },
                  },
                  "& input": {
                    padding: "10px 14px",
                    fontSize: "14px",
                  },
                }}
              />

              {/* Submit Button */}
              <Button
                type="submit"
                fullWidth
                sx={{
                  mt: 1.5,
                  py: 1,
                  fontSize: "14px", // smaller button
                  backgroundColor: "#3B035E",
                  color: "white",
                  fontWeight: 600,
                  borderRadius: "10px",
                  "&:hover": { backgroundColor: "#3B035E" },
                }}
              >
                Sign Up
              </Button>
            </form>

            {/* Login Link */}
            <Box mt={2.5} textAlign="center">
              <Typography fontSize="14px" fontWeight={500}>
                Already Enrolled?{" "}
                <a href="/login" style={{ color: "#3B035E", fontWeight: 700 }}>
                  Login Here
                </a>
              </Typography>
            </Box>

            {/* OTP Modal + Snackbar */}
            <OtpModal
              open={otpOpen}
              onClose={() => setOtpOpen(false)}
              onVerify={(enteredOtp) => handleOtpVerify(enteredOtp)}
              countryCode={countryCode}
              mobile={mobile}
            />

            <CustomSnackbar
              open={snackbarOpen}
              onClose={() => setSnackbarOpen(false)}
              message={snackbarMessage}
              severity={snackbarSeverity}
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default RegisterPage2;
